import { Injectable } from '@angular/core';
import { SearchableEntityDataService } from './searchable-entity-data.service';
import { SearchableEntityActionService } from './searchable-entity-action.service';
import { SearchableEntityButtonService } from './searchable-entity-button.service';
import { SearchableEntityDataEditorService } from './searchable-entity-data-editor.service';
import { SearchableEntityBackendService } from './searchable-entity-backend.service';

@Injectable()
export class SearchableEntityServiceFactory {

  constructor(protected dataService: SearchableEntityDataService,
    protected actionService: SearchableEntityActionService,
    protected backendService: SearchableEntityBackendService,
    protected dataEditor: SearchableEntityDataEditorService,
    protected buttonService: SearchableEntityButtonService) {
    if (dataService) {
      dataService.setDependentServices(dataEditor, buttonService);
    }
    if (actionService) {
      actionService.setDependentServices(dataService, buttonService, dataEditor, backendService);
    }
    if (backendService) {
      backendService.setDependentServices(dataService);
    }
    if (dataEditor) {
      dataEditor.setDependentServices(dataService, backendService, actionService);
    }
    if (buttonService) {
      buttonService.setDependentServices(dataService, actionService);
    }
  }

  public getDataService(): SearchableEntityDataService {
    return this.dataService;
  }

  public getActionService(): SearchableEntityActionService {
    return this.actionService;
  }

  public getDataEditor(): SearchableEntityDataEditorService {
    return this.dataEditor;
  }

  public getBackendService(): SearchableEntityBackendService {
    return this.backendService;
  }

  public getButtonService(): SearchableEntityButtonService {
    return this.buttonService;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/services/searchable-entity/searchable-entity-service-factory.ts